import {
  MYPAGE_HISTORY_REQUEST,
  MYPAGE_HISTORY_REQUEST_SUCCESS,
  MYPAGE_HISTORY_REQUEST_FAIL
} from 'constants/action-types';

const initialState = {
  headerInfo: {
    orderDate: '',
    orderNo: '',
    paymentStatus: ''
  },
  orderInfo: {
    postcode: '',
    address: '',
    email: '',
    purchaseItems: [],
    mean: '',
    billingAmount: '',
    deliveryItem: [],
    name: '',
    nameKana: '',
    telephone: '',
    totalDeliveryPrice: '',
    totalVoucherPrice: ''
  },
  deliveryInfo: [],
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case MYPAGE_HISTORY_REQUEST:
      return initialState;

    case MYPAGE_HISTORY_REQUEST_SUCCESS:
      const {
        info: { orderOn, projectId, orderInfo, mean, paymentStatus },
        deliveryInfo
      } = action.payload.data;

      return {
        ...state,
        headerInfo: {
          orderOn,
          projectId,
          paymentStatus
        },
        orderInfo: {
          ...orderInfo,
          mean
        },
        deliveryInfo: deliveryInfo.map((delivery, index) => ({
          ...delivery,
          index: index + 1
        }))
      };

    case MYPAGE_HISTORY_REQUEST_FAIL:
      return {
        ...state,
        error: action.error.response
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/mypage/history.js